module.exports = __webpack_public_path__ + "media/EconomX_hero_animation.a0cd2dfd.mp4";